import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { firstValueFrom } from "rxjs";
import { CategoryService } from "./category-wise-report.services";
import * as categoryWiseStrings from "../stringFiles/categoryWiseReport.json";
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var customToastr: any;

@Component({
  selector: "app-category-wise-report",
  providers: [CategoryService],
  templateUrl: "./category-wise-report.component.html",
  styleUrls: [
    "./category-wise-report.component.css",
    "./../../assets/css/theme-default/materialadmin.css",
    "./../../assets/css/theme-default/font-awesome.min.css",
    "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
    "./../../assets/css/theme-default/material-design-iconic-font.min.css",
    "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
    "./../../_crop/css/style.css",
    "./../../_crop/css/style-example.css",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CategoryWiseReportComponent {
  isExpanded: boolean = false;
  wingId: string = "All";
  wingListData: any = [];
  classStandardData: any = [];
  classSectionData: any[] = [];
  categoryData: [];
  genderData: [];
  fetchingClassData: boolean = false;
  fetchingSectionData: boolean = false;
  fetchingStatData: boolean = false;
  studentStatDataInfo: [];
  resultAvailable: string = "";
  selectedWing: any = null;
  selectedClass: any = null;
  selectedSection: any = null;
  selectedCaste: any = null;
  selectedGender: any = null;
  enableReset: boolean = false;
  appliedFilterData: any;
  isExpandStatContainerData: boolean = false;
  columnIndex: string = "";
  pageLimit: string = "10";
  pageNumbers: number[];
  maxPageNumber: number;
  startingPageNumber: number = 1;
  fetchingTableData: boolean = true;
  stringsData: any;
  tableColumnData: string[];
  tableRowData: [];
  isExportingReport: boolean = false;
  lang: string = "en";

  appliedWing: any = "All";
  appliedClassStandard: any = "All";
  appliedClassId: any = "All";
  appliedGender: any = "All";
  appliedCaste: any = "All";

  allWingSelected: boolean = false;

  loadingClassData: boolean = true;
  loadingSectionData: boolean = true;

  selectedWings: any = [];
  openOptionForWingSelection: boolean = false;
  openOptionForClassSelection: boolean = false;
  openOptionForSectionSelection: boolean = false;

  @ViewChild("scrollableDiv") scrollableDiv!: ElementRef<HTMLDivElement>;

  constructor(private categoryServices: CategoryService, private translate: TranslateService) {
    this.initScript();
    this.getWingListData();
    this.getCategoryList();
    this.getGenderListData();
    this.getStatDataStudent();
    this.getCategoryWiseTableData(this.pageLimit);
    this.getClassStandardList("All");
    this.getClassSectionList("All", "All");
    this.stringsData = categoryWiseStrings;
  }

  // function for expand filter
  expandFilters() {
    this.isExpanded = !this.isExpanded;
  }

  // function for open column function
  expandColumnOption(index) {
    if (index === this.columnIndex) {
      this.columnIndex = "";
    } else {
      this.columnIndex = index;
    }
  }

  // function for close table column options
  collapseColumnOption() {
    event.stopPropagation();
    this.columnIndex = "";
  }

  // function for scroll stat data
  scrollStatData(direction: "left" | "right"): void {
    const div = this.scrollableDiv.nativeElement;
    if (direction === "left") {
      div.scrollBy({ left: -250, behavior: "smooth" });
    } else if (direction === "right") {
      div.scrollBy({ left: 250, behavior: "smooth" });
    }
  }

  // function for expand stats container
  openStudentStatsContainer() {
    this.isExpandStatContainerData = !this.isExpandStatContainerData;
  }

  // init script for toast messages
  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
        "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
        "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
        "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
        "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
        "toastr[type](message, '');return 0;} </" +
        "script>"
    );
  }

  // function for get wing list for selection
  async getWingListData() {
    try {
      const response: any = await firstValueFrom(
        this.categoryServices.getWingData()
      );
      if (response.status && response.body) {
        this.wingListData = response.body.classCategoryListDetails
          ? response.body.classCategoryListDetails
          : [];
        this.selectAllWingByDefault();
      } else {
        this.wingListData = [];
      }
    } catch (error) {
      this.wingListData = [];
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
        customToastr(errorMessageTranslation, this.stringsData.error);
      }
    }
  }

  // function for get class standard
  async getClassStandardList(wingInfo) {
    try {
      this.loadingClassData = true;
      this.selectedClass = null;
      this.selectedSection = null;
      this.classStandardData = [];
      this.classStandardData = [];
      this.fetchingClassData = true;
      let body = {
        lang: "en",
        classCategoryIds:
          Array.isArray(wingInfo) && wingInfo.length > 0 ? wingInfo : "All",
      };

      const response: any = await firstValueFrom(
        this.categoryServices.getClassStandardListData(body)
      );

      if (response.status && response.body) {
        this.classStandardData = response.body.classCategoryListData
          ? response.body.classCategoryListData
          : [];
        this.selectAllClassByDefault();
      } else {
        this.classStandardData = [];
      }
      this.loadingClassData = false;
      this.fetchingClassData = false;
    } catch (error) {
      this.classStandardData = [];
      this.loadingClassData = false;
      this.fetchingClassData = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong')); 
        customToastr(
          somethingWentWrongTranslation,
          this.stringsData.error
        );
      }
    }
  }

  // function for get class section list
  async getClassSectionList(classCategoryId, classStandardId) {
    try {
      this.loadingSectionData = true;
      this.selectedSection = null;
      this.fetchingSectionData = true;
      const body = {
        lang: "en",
        classStandardIds:
          Array.isArray(classCategoryId) && classCategoryId.length > 0
            ? classCategoryId
            : "All",
        classCategoryIds:
          Array.isArray(classStandardId) && classStandardId.length > 0
            ? classStandardId
            : "All",
      };
      const response: any = await firstValueFrom(
        this.categoryServices.getClassSectionDataInfo(body)
      );
      if (response.status && response.body) {
        this.classSectionData = response.body.classSectionListData
          ? response.body.classSectionListData
          : [];
        this.selectAllSectionByDefault();
      }
      this.loadingSectionData = false;
      this.fetchingSectionData = false;
    } catch (error) {
      this.classSectionData = [];
      this.loadingSectionData = false;
      this.fetchingSectionData = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong')); 
        customToastr(
          somethingWentWrongTranslation,
          this.stringsData.error
        );
      }
    }
  }

  // function for get class section list
  async getCategoryList() {
    try {
      const response: any = await firstValueFrom(
        this.categoryServices.getCategoryData()
      );

      if (response.status && response.body) {
        this.categoryData = response.body.castCategoryListDetails
          ? response.body.castCategoryListDetails
          : [];
      } else {
        this.categoryData = [];
      }
    } catch (error) {
      this.categoryData = [];
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
        customToastr(errorMessageTranslation, this.stringsData.error);
      }
    }
  }

  // function for get class section list
  async getGenderListData() {
    try {
      const response: any = await firstValueFrom(
        this.categoryServices.getGenderList()
      );
      if (response.status && response.body) {
        this.genderData = response.body.studentGenderListDetails
          ? response.body.studentGenderListDetails
          : [];
      } else {
        this.genderData = [];
      }
    } catch (error) {
      this.genderData = [];
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong')); 
        customToastr(
          somethingWentWrongTranslation,
          this.stringsData.error
        );
      }
    }
  }

  closeSectionSelection() {
    this.openOptionForSectionSelection = false;
  }

  openOptionSectionSelectionData(event) {
    this.openOptionForSectionSelection = true;
  }
  // function for apply filter
  applyFilter() {
    this.enableReset = true;
    this.closeAllOptions();
    this.startingPageNumber = 1;
    if (this.checkAllClassStandard()) {
      this.selectAllClassByDefault();
    }
    if (this.checkAllWingUnchecked()) {
      this.selectAllWingByDefault();
    }
    if (this.checkAllClassSectionChecked()) {
      this.selectAllSectionByDefault();
    }
    const all = "All";
    this.appliedWing =
      this.getWingsIds().length > 0 &&
      this.getWingsIds().length != this.wingListData.length
        ? this.getWingsIds()
        : all;
    this.appliedClassId =
      this.getSectionIds().length > 0 &&
      this.getSectionIds().length != this.classSectionData.length
        ? this.getSectionIds()
        : all;
    this.appliedClassStandard =
      this.getClassIds().length > 0 &&
      this.getClassIds().length != this.classStandardData.length
        ? this.getClassIds()
        : all;
    this.appliedCaste =
      this.selectedCaste != null ? this.selectedCaste.castCategory : all;
    this.appliedGender =
      this.selectedGender != null ? this.selectedGender.studentGender : all;

    const body = [
      {
        wing:
          this.selectedWing != null ? this.selectedWing.classCategoryName : all,
        class:
          this.selectedClass != null
            ? this.selectedClass.classStandardName
            : all,
        section:
          this.selectedSection != null
            ? this.selectedSection.classDivision
            : all,
        caste:
          this.selectedCaste != null ? this.selectedCaste.castCategory : all,
        gender:
          this.selectedGender != null ? this.selectedGender.studentGender : all,
      },
    ];
    this.closeSectionSelection();
    this.getStatDataStudent();
    this.closeClassOption();
    this.getCategoryWiseTableData(this.pageLimit);
    this.appliedFilterData = body;
  }

  // function for apply filter after reset the filter data
  applyAfterResetFilter() {
    this.enableReset = true;
    this.startingPageNumber = 1;
    const all = "All";
    this.closeAllOptions();
    this.appliedWing = all;
    this.appliedClassId = all;
    this.appliedClassStandard = all;
    this.appliedCaste = all;
    this.appliedGender = all;
    const body = [
      {
        wing:
          this.selectedWing != null ? this.selectedWing.classCategoryName : all,
        class:
          this.selectedClass != null
            ? this.selectedClass.classStandardName
            : all,
        section:
          this.selectedSection != null
            ? this.selectedSection.classDivision
            : all,
        caste:
          this.selectedCaste != null ? this.selectedCaste.castCategory : all,
        gender:
          this.selectedGender != null ? this.selectedGender.studentGender : all,
      },
    ];
    this.getStatDataStudent();
    this.getCategoryWiseTableData(this.pageLimit);
    this.appliedFilterData = body;
  }

  // function for reset filter
  resetFilter() {
    this.selectedWing = null;
    this.selectedClass = null;
    this.selectedSection = null;
    this.selectedCaste = null;
    this.selectedGender = null;
    this.appliedFilterData = null;
    this.getClassStandardList("All");
    this.getClassSectionList("All", "All");
    this.selectAllWingByDefault();
    this.applyAfterResetFilter();
    this.enableReset = false;
    this.getStatDataStudent();
  }

  // function for select all wing
  applyAllWing(event) {
    this.selectedClass = null;
    this.selectedSection = null;
    if (event.target.checked) {
      this.markAllSelectWing();
    } else {
      this.unMarkAllSelectWing();
    }
  }

  // function to fetch stat data
  async getStatDataStudent() {
    try {
      this.fetchingStatData = true;
      const schoolData = localStorage.getItem("schoolAllInfo");
      const schoolInfo = schoolData ? JSON.parse(schoolData) : null;
      const body = {
        classCategoryIds: this.appliedWing,
        classStandardIds: this.appliedClassStandard,
        classIds: this.appliedClassId,
        gender: this.appliedGender,
        castCategory: this.appliedCaste,
        lang: "en",
        academicId: schoolInfo.currentAcademicId,
      };
      const response: any = await firstValueFrom(
        this.categoryServices.getStudentStatDataInformation(body)
      );

      if (response.status && response.body) {
        this.resultAvailable = response.body.resultAvailable
          ? response.body.resultAvailable
          : "0";
        this.studentStatDataInfo = response.body.castCategoryWiseCount
          ? response.body.castCategoryWiseCount
          : [];
      } else {
        this.resultAvailable = "0";
        this.studentStatDataInfo = [];
      }
      this.fetchingStatData = false;
    } catch (error) {
      this.fetchingStatData = false;
      this.resultAvailable = "0";
      this.studentStatDataInfo = [];
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
        customToastr(errorMessageTranslation, this.stringsData.error);
      }
    }
  }

  closeAllOptions() {
    this.openOptionForWingSelection = false;
    this.openOptionForClassSelection = false;
    this.openOptionForSectionSelection = false;
  }

  // function for get category wise table data with all info
  async getCategoryWiseTableData(pageLimit) {
    try {
      this.fetchingTableData = true;
      const schoolData = localStorage.getItem("schoolAllInfo");
      const schoolInfo = schoolData ? JSON.parse(schoolData) : null;
      const body = {
        classCategoryIds: this.appliedWing,
        classStandardIds: this.appliedClassStandard,
        classIds: this.appliedClassId,
        gender: this.appliedGender,
        castCategory: this.appliedCaste,
        pageLimit: pageLimit,
        pageNumber: this.startingPageNumber,
        lang: "en",
        academicId: schoolInfo.currentAcademicId,
      };
      const response: any = await firstValueFrom(
        this.categoryServices.getStudentCategoryWiseDataInfo(body)
      );
      if (response && response.body && response.status) {
        if (this.tableColumnData == undefined) {
          this.tableColumnData = response.body.reportColumnList
            ? response.body.reportColumnList
            : [];
        }
        this.tableRowData = response.body.reportStudentData
          ? response.body.reportStudentData
          : [];
        this.generatePageNumber(
          response.body.maxPageNumber ? response.body.maxPageNumber : 1
        );
      } else {
        this.tableColumnData = [];
        this.tableRowData = [];
      }
      this.fetchingTableData = false;
    } catch (error) {
      this.tableColumnData = [];
      this.tableRowData = [];
      this.fetchingTableData = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
        customToastr(errorMessageTranslation, this.stringsData.error);
      }
    }
  }

  // function for update table column
  async updateTableColumn(currentSlug, newSlug) {
    const currentSlugDataIndex = this.tableColumnData.findIndex((item) => {
      const data = item as any;
      return data.slug === currentSlug;
    });
    const newSlugDataIndex = this.tableColumnData.findIndex((item) => {
      const data = item as any;
      return data.slug === newSlug;
    });
    if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
      const slugCurrentData = this.tableColumnData[currentSlugDataIndex];
      const slugNewData = this.tableColumnData[newSlugDataIndex];
      const currentInfo = slugCurrentData as any;
      const newInfo = slugNewData as any;
      currentInfo.isDefault = 0;
      newInfo.isDefault = 1;
      if (this.tableColumnData.length > 0) {
        this.tableColumnData[currentSlugDataIndex] = newInfo;
        this.tableColumnData[newSlugDataIndex] = currentInfo;
      }
    }
  }

  // function for update table length list
  changePageLimitData(pageNumber) {
    this.startingPageNumber = 1;
    this.pageLimit = pageNumber;
    this.getCategoryWiseTableData(this.pageLimit);
  }

  // function for generate page number
  generatePageNumber(maxPage) {
    this.maxPageNumber = maxPage;
    let displayedPages = [];
    let currentPage = this.startingPageNumber;
    if (currentPage === 1) {
      displayedPages.push(
        ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
      );
    } else if (currentPage === maxPage) {
      displayedPages.push(
        ...Array.from(
          { length: Math.min(5, maxPage) },
          (_, i) => maxPage - 4 + i
        )
      );
    } else if (currentPage >= 4 && currentPage <= maxPage - 3) {
      displayedPages.push(
        ...Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
      );
    } else if (currentPage < 4) {
      displayedPages.push(
        ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
      );
    } else if (currentPage > maxPage - 4) {
      displayedPages.push(
        ...Array.from(
          { length: Math.min(5, maxPage) },
          (_, i) => maxPage - 4 + i
        )
      );
    }
    displayedPages = displayedPages
      .filter((page) => page > 0 && page <= maxPage)
      .sort((a, b) => a - b);
    if (!displayedPages.includes(maxPage)) {
      displayedPages.push("...");
      displayedPages.push(maxPage);
    }
    this.pageNumbers = displayedPages;
  }

  // function for change page number through left right button
  changePage(pageValue) {
    if (pageValue != 0 && pageValue <= this.maxPageNumber) {
      this.startingPageNumber = pageValue;
      this.getCategoryWiseTableData(this.pageLimit);
    }
  }

  // function for jump page number on click of page number
  switchPageNumber(pageNumber) {
    this.startingPageNumber = pageNumber;
    this.getCategoryWiseTableData(this.pageLimit);
  }

  // function for export category wise report and download it directly
  async exportReport() {
    try {
      this.isExportingReport = true;
      const tableColumnArray = [];
      for (let j = 0; j < this.tableColumnData.length; j++) {
        const tableData: any = this.tableColumnData[j];
        if (tableData.isDefault == 1) {
          tableColumnArray.push(tableData.pkReportColumnMapDetailId);
        }
      }

      const schoolData = localStorage.getItem("schoolAllInfo");
      const schoolInfo = schoolData ? JSON.parse(schoolData) : null;
      const body = {
        lang: this.lang,
        academicId: schoolInfo.currentAcademicId,
        exportType: this.stringsData.reportFormat,
        selectedColumns: tableColumnArray,
        emailIdList: [],
        classCategoryIds: this.appliedWing,
        classStandardIds: this.appliedClassStandard,
        classIds: this.appliedClassId,
        gender: this.selectedGender
          ? this.selectedGender.studentGender
          : this.stringsData.all,
        castCategory: this.selectedCaste
          ? this.selectedCaste.castCategory
          : this.stringsData.all,
      };
      const response: any = await firstValueFrom(
        this.categoryServices.exportCategoryReportData(body)
      );
      if (response instanceof Blob) {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = url;
        a.download = "CategoryWiseReport.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      }
      const successMsg = await firstValueFrom(this.translate.get('reportExportedSuccessfully'));
      customToastr(successMsg, "success");
    } catch (error) {
      const errorExportTranslation = await firstValueFrom(this.translate.get('errorExport'));
      customToastr(
        error.error && error.error.message
          ? error.error.message
          : errorExportTranslation,
        "error"
      );
    } finally {
      this.isExportingReport = false;
    }
  }
  // function for multi select
  selectMultipleWing(index: any) {
    const findData = this.wingListData[index];
    findData.isChecked = !findData.isChecked;
    this.wingListData[index] = findData;
    const wingInfo = this.getWingsIds();
    this.getClassStandardList(wingInfo);
    const classData = this.getClassIds();
    this.getClassSectionList(classData, wingInfo);
  }

  // function for multi select
  unselectWing() {
    this.wingListData = this.wingListData.map((wing: any) => ({
      ...wing,
      isChecked: false,
    }));
  }
  // function for multi select
  selectMultipleClass(index: any) {
    const findData = this.classStandardData[index];
    findData.isChecked = !findData.isChecked;
    this.classStandardData[index] = findData;
    const classData = this.getClassIds();
    const wingInfo = this.getWingsIds();
    this.getClassSectionList(classData, wingInfo);
    this.updateWingCheckStatus();
  }

  // function for multi select
  selectMultipleSection(index: any) {
    const findData = this.classSectionData[index];
    findData.isChecked = !findData.isChecked;
    this.classSectionData[index] = findData;
    this.getSectionIds();
    this.updateClassStatusCheckStatus();
  }
  // function fot mark all wing
  markAllSelectWing() {
    this.wingListData = this.wingListData.map((student) => {
      return { ...student, isChecked: true };
    });
  }
  // function fot unmark all wing
  unMarkAllSelectWing() {
    this.wingListData = this.wingListData.map((student) => {
      return { ...student, isChecked: false };
    });

    const wingInfo = this.getWingsIds();
  }

  // function for get wing id
  getWingsIds() {
    return this.wingListData
      .filter((wing) => wing.isChecked)
      .map((wing) => wing.categoryId);
  }

  // function for get section id
  getSectionIds() {
    return this.classSectionData
      .filter((classSection) => classSection.isChecked)
      .map((classSection) => classSection.classId);
  }

  // function for get class id for selected class
  getClassIds() {
    return this.classStandardData
      .filter((classStandard) => classStandard.isChecked)
      .map((classStandard) => classStandard.pkClassStandardsId);
  }

  // function for open wing option
  openWingOption(event: KeyboardEvent) {
    event.stopPropagation();
    this.openOptionForWingSelection = true;
  }

  // function for close wing option
  closeWingOption() {
    event.stopPropagation();
    this.openOptionForWingSelection = false;
  }

  // function for open class option
  openClassOption(event: KeyboardEvent) {
    event.stopPropagation();
    this.openOptionForClassSelection = true;
  }

  // function for close class option
  closeClassOption() {
    event.stopPropagation();
    this.openOptionForClassSelection = false;
  }

  // function for open section option
  openSectionOption(event: KeyboardEvent) {
    event.stopPropagation();
    this.openOptionForSectionSelection = true;
  }
  // function for mark all button for wing
  getStatusOfWing() {
    const allTrue = this.wingListData.every((item) => item.isChecked);
    const allFalse = this.wingListData.every((item) => !item.isChecked);
    return allTrue || allFalse;
  }

  // function for mark all button for class
  getClassStatus() {
    const allTrue = this.classStandardData.every((item) => item.isChecked);
    const allFalse = this.classStandardData.every((item) => !item.isChecked);
    return allTrue || allFalse;
  }

  // function for mark all button for section

  getSectionStatus() {
    const allTrue = this.classSectionData.every((item) => item.isChecked);
    const allFalse = this.classSectionData.every((item) => !item.isChecked);
    return allTrue || allFalse;
  }

  // // function for mark all wing
  selectAllWing(event) {
    this.wingListData = this.wingListData.map((data) => ({
      ...data,
      isChecked: event.target.checked,
    }));
    this.getStatusOfWing();
    const wingInfo = this.getWingsIds();
    this.getClassStandardList(wingInfo);
    const classData = this.getClassIds();
    this.getClassSectionList(classData, wingInfo);
  }

  // function for mark all wing by default
  selectAllWingByDefault() {
    this.wingListData = this.wingListData.map((data) => ({
      ...data,
      isChecked: true,
    }));
    this.getStatusOfWing();
  }

  // function for mark all class
  selectAllClass(event) {
    this.classStandardData = this.classStandardData.map((data) => ({
      ...data,
      isChecked: event.target.checked,
    }));
    this.getClassStatus();
    const wingInfo = this.getWingsIds();
    const classData = this.getClassIds();
    this.getClassSectionList(classData, wingInfo);
  }

  // In starting mark all class by default
  selectAllClassByDefault() {
    this.classStandardData = this.classStandardData.map((data) => ({
      ...data,
      isChecked: true,
    }));
    this.getClassStatus();
  }

  // function starting mark all section
  selectAllSection(event) {
    this.classSectionData = this.classSectionData.map((data) => ({
      ...data,
      isChecked: event.target.checked,
    }));
    this.getSectionStatus();
  }

  // In starting mark all section by default
  selectAllSectionByDefault() {
    this.classSectionData = this.classSectionData.map((data) => ({
      ...data,
      isChecked: true,
    }));
    this.getSectionStatus();
  }

  // function for status for all checkbox for classStandard
  checkAllClassStandard() {
    return this.classStandardData.every((data) => !data.isChecked);
  }

  // function for status for all checkbox for section
  checkAllWingUnchecked() {
    return this.wingListData.every((data) => !data.isChecked);
  }

  // function for status for all checkbox for class
  checkAllClassSectionChecked() {
    return this.classSectionData.every((data) => !data.isChecked);
  }

  // function for reverse unselect checkbox for wing
  updateWingCheckStatus() {
    this.wingListData = this.wingListData.map((wing) => {
      const wingClasses = this.classStandardData.filter(
        (data) => data.categoryId === wing.categoryId
      );
      const allUnchecked = wingClasses.every((data) => !data.isChecked);
      return { ...wing, isChecked: !allUnchecked };
    });
  }

  // function for reverse unselect checkbox for class
  updateClassStatusCheckStatus() {
    this.classStandardData = this.classStandardData.map((wing) => {
      const classes = this.classSectionData.filter(
        (data) => data.pkClassStandardsId === wing.pkClassStandardsId
      );
      const allUnchecked = classes.every((data) => !data.isChecked);
      return { ...wing, isChecked: !allUnchecked };
    });
    this.updateWingCheckStatus();
  }
}